import React from 'react'

import './DrawerToggle.css'

const drawerToggleButton = props => (
  <button className="toggle-button">
    <div className="toggle-button__line" />
    <div className="toggle-button__line" />
    <div className="toggle-button__line" />
  </button>
)

export default drawerToggleButton